<template>
  <div
    class="blackScreen"
    style="
      background: rgba(0, 0, 0, 0.5);
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
    "
  >
    <div
      style="
        width: 90%;
        height: 65%;
        position: absolute;
        margin: 0 auto;
        background: white;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
        border-radius: 10px;
      "
    >
      <div
        style="
          display: flex;
          position: relative;
          height: 100%;
          flex-flow: column nowrap;
          justify-content: space-evenly;
          align-items: center;
          /*padding: 50px;*/
        "
      >
        <div
          style="
            display: flex;
            flex-flow: column;
            justify-content: space-around;
            height: 15%;
          "
        >
          <img
            src="../../../../src/assets/img/clos_bt.png"
            style="
              width: 40px;
              position: absolute;
              top: -70px;
              left: 0;
              right: 0;
              margin: auto;
            "
            @click="closePopup"
          />

          <h1 style="font-size: 30px">입장을 위한 QR코드</h1>
          <h3>이용할 시설에 QR 코드로 체크인 해주세요</h3>
        </div>
        <div>
          <div style="margin: 0 auto; position: relative">
            <vue-q-r-code-component :size="200" :text="String(response.qrId)" />
          </div>
          <div
            style="
              display: flex;
              flex-flow: row nowrap;
              justify-content: center;
              align-items: center;
              height: 30px;
              margin-top: 50px;
            "
          >
            <img src="../../../../src/assets/img/time_icon.png" />
            <h3 style="margin-left: 3px">{{ count }}</h3>
          </div>
        </div>
        <div
          v-if="!count"
          style="
            background: rgba(255, 255, 255, 0.75);
            width: 100%;
            height: 100%;
            position: absolute;
            border-radius: 10px;
            display: flex;
          "
        >
          <div
            style="
              position: relative;
              display: flex;
              flex-flow: column nowrap;
              justify-content: center;
              align-items: center;
              margin: auto;
            "
          >
            <img
              src="../../../../src/assets/img/reset_bt.png"
              style="position: relative"
              @click="refreshCreate"
            />
            <span style="font-weight: bold">재발급</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueQRCodeComponent from "vue-qrcode-component";
import ProjectAPI from "@/api/ProjectAPI";
export default {
  name: "QrcodeCreatePopup",
  components: {
    VueQRCodeComponent,
  },
  data() {
    return {
      params: {},
      response: {},
      count: null,
    };
  },
  methods: {
    show(info) {
      this.params = info;
      this.init();
    },
    async init() {
      const { data } = await ProjectAPI.postQrCodeCreate(this.params);
      this.response.qrId = `&${data.qrId}%`;
      this.initTime();
    },
    initTime() {
      this.count = 30;
      const init = setInterval(() => {
        this.count--;
        if (this.count === 0) {
          this.clearTime(init);
        }
      }, 1000);
    },
    clearTime(init) {
      clearInterval(init);
      this.response.qrId = "";
    },
    refreshCreate() {
      this.init();
    },
    closePopup() {
      this.$emit("closeQrPopup");
    },
  },
};
</script>

<style scoped></style>
